import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccess } from '../../../services/api';
import routes from '../../../constants/routes';
import styled from 'styled-components';
import { trackEvent } from '../../../services/analytics';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
`;

const Card = styled.div`
  text-align: center;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0 0 1rem 0;
  color: #4ade80;
`;

const Message = styled.p`
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
`;

const POLL_DELAYS = [500, 1000, 2000, 4000];

export const BillingSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'processing' | 'success' | 'timeout'>('processing');

  useEffect(() => {
    trackEvent('billing_success_processing_view');
    let attempt = 0;

    const pollAccess = async () => {
      try {
        const access = await getAccess();
        if (access.tier === 'active') {
          trackEvent('billing_success_confirmed_active');
          setStatus('success');
          setTimeout(() => {
            navigate(routes.LANDING, { replace: true });
          }, 1500);
          return;
        }
      } catch {
        // Ignore errors, keep polling
      }

      attempt++;
      if (attempt < POLL_DELAYS.length) {
        setTimeout(pollAccess, POLL_DELAYS[attempt]);
      } else {
        trackEvent('billing_success_timeout');
        setStatus('timeout');
        setTimeout(() => {
          navigate(routes.LANDING, { replace: true });
        }, 2000);
      }
    };

    setTimeout(pollAccess, POLL_DELAYS[0]);
  }, [navigate]);

  return (
    <Container>
      <Card>
        {status === 'processing' && (
          <>
            <Title>processing</Title>
            <Message>confirming your subscription...</Message>
          </>
        )}
        {status === 'success' && (
          <>
            <Title>subscribed</Title>
            <Message>redirecting to terminal...</Message>
          </>
        )}
        {status === 'timeout' && (
          <>
            <Title>processing</Title>
            <Message>taking longer than expected. redirecting...</Message>
          </>
        )}
      </Card>
    </Container>
  );
};
